/**
 * `/app/widgets/$widgetRef/posts/$postRef` — one post's editor, for the client
 * (`.docs/46-blog-and-forms.md` §7). The page is `pages/blog/PostEditorPage.tsx`, the
 * one the studio mounts too, through `ClientBlog`. The editor itself is loaded lazily by
 * the page (`pages/blog/LazyEditor.tsx`), so nothing of TipTap ships with the shell.
 *
 * Both parameters are references, and one that is not names nothing: a not-found here,
 * inside the portal, rather than a page asking the API about a string.
 */

import { isRef } from '@fareast/shared'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { NotFound } from '../../../../../errors/NotFound.js'
import { PostEditorPage } from '../../../../../pages/blog/PostEditorPage.js'
import { ClientBlog } from '../../../../../pages/client/blog/ClientBlog.js'

export const Route = createFileRoute('/app/widgets/$widgetRef/posts/$postRef')({
  beforeLoad: ({ params }) => {
    if (!isRef('widget', params.widgetRef) || !isRef('post', params.postRef)) throw notFound()
  },
  /** R3-13: a refusal under this route keeps the portal around it. */
  notFoundComponent: NotFound,
  component: PostRoute,
})

function PostRoute() {
  const { widgetRef, postRef } = Route.useParams()
  return (
    <ClientBlog widgetRef={widgetRef}>
      <PostEditorPage postRef={postRef} />
    </ClientBlog>
  )
}
